export const customThemeTable = {
    table: {
        style: {
            color: '#fff',
            backgroundColor: '#D9D9D9',
            // maxHeight: '100%',
            margin: 0,
            width: '100%'
        }
    },
    tableWrapper: {
        style: {
            display: 'block',
            borderRadius: '0px',
            // maxHeight: '100%',
            width: '100%'
            // border: '1px solid red'
        }
    },
    rows: {
        style: {
            fontSize: '10px',
            fontWeight: 400,
            backgroundColor: '#D9D9D9',
            maxHeight: '20px',
            minHeight: '20px',
            height: '20px',
            borderBottom: '0.3px solid grey'
        }
    },
    headRow: {
        style: {
            fontSize: '11px',
            fontWeight: 600,
            color: "white",
            backgroundColor: '#6D6A70',
            maxHeight: '1.5vmax',
            minHeight: '1.5vmax',
            height: '1.5vmax',
            padding: '0.3vmax'
        }
    },
    pagination: {
        style: {
            color: 'black',
            fontSize: '0.8vmax',
            minHeight: '28px',
            backgroundColor: '#D9D9D9',
            width: '100%',
            padding: '0px',
            margin: '0px',
            border: '0px'
        },
        pageButtonsStyle: {
            borderRadius: '50%',
            height: '40px',
            width: '40px',
            padding: 'px',
            margin: 'px',
            cursor: 'pointer',
            transition: '0.4s',
            color: 'black',
            fill: 'black',
            backgroundColor: 'transparent',
            '&:disabled': {
                cursor: 'unset',
                color: 'grey',
                fill: 'grey'
            },
            '&:hover:not(:disabled)': {
                backgroundColor: 'grey'
            },
            '&:focus': {
                outline: 'none',
                backgroundColor: '#D9D9D9'
            }
        }
    }
}

export const iconSx = {
    cursor: 'pointer',
    fontSize: '18px'
}
